<template>
  <nav>
    <ul class="pager">
      <li :class="{'disabled': !hasPreviousPage}">
        <a href="#" @click.prevent="previous">
          <i class="fa fa-angle-double-left"></i> Previous
        </a>
      </li>

      <li>
        <div class="pager-page">
          {{ currentPage }} / {{ lastPage }}
        </div>
      </li>

      <li :class="{'disabled': !hasNextPage}">
        <a href="#" @click.prevent="next">
          Next <i class="fa fa-angle-double-right"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<style>
.pager-page {
  display: inline-block;
  padding: 5px 14px;
  background-color: #337ab7;
  color: #ffffff;
  border-radius: 15px;
}
</style>

<script>
export default {
  props: {'currentPage': {}, 'lastPage': {}},

  computed: {
    hasPreviousPage() {
      return this.currentPage !== 1
    },

    hasNextPage() {
      return this.currentPage !== this.lastPage
    }
  },

  methods: {
    previous() {
      if (this.hasPreviousPage) {
        this.$emit('navigate', this.currentPage - 1)
      }
    },

    next() {
      if (this.hasNextPage) {
        this.$emit('navigate', this.currentPage + 1)
      }
    }
  }
}
</script>
